module.exports = __webpack_public_path__ + "img/cz.3c3913d0.png";